const childRoutes = prop => [
    {
        path: 'services-list',
        name: prop + '.services_list',
        meta: { auth: true },
        component: () => import('../pages/services/List.vue')
    },
    {
        path: 'donation-mode-list',
        name: prop + '.donation_mode_list',
        meta: { auth: true },
        component: () => import('../pages/donation-mode/List.vue')
    },
    {
        path: 'hospital-department-list',
        name: prop + '.hospital_department_list',
        meta: { auth: true },
        component: () => import('../pages/hospital-department/List.vue')
    },
    {
        path: 'bank-info/bank-name',
        name: prop + '.bank_name',
        meta: { auth: true },
        component: () => import('../pages/bank-info/bank-name/List.vue')
    },
    {
        path: 'disease-info',
        name: prop + '.disease_info',
        meta: { auth: true },
        component: () => import('../pages/disease-info/List.vue')
    },
    {
        path: 'van-info',
        name: prop + '.van_info',
        meta: { auth: true },
        component: () => import('../pages/van-info/List.vue')
    },
    {
        path: 'disability-type-list',
        name: prop + '.disability_type_list',
        meta: { auth: true },
        component: () => import('../pages/disability-type/List.vue')
    },
    {
        path: 'driver-assign',
        name: prop + '.driver_assign',
        meta: { auth: true },
        component: () => import('../pages/driver-assign/List.vue')
    },
    {
        path: 'dc-pool',
        name: prop + '.dc_pool',
        meta: { auth: true },
        component: () => import('../pages/dc-pool/List.vue')
    },
    {
        path: 'driver-info',
        name: prop + '.driver_info',
        meta: { auth: true },
        component: () => import('../pages/driver-info/List.vue')
    },
    {
        path: 'sub-center',
        name: prop + '.sub_center',
        meta: { auth: true },
        component: () => import('../pages/sub-center/List.vue')
    },
    {
        path: 'van-assign',
        name: prop + '.van_assign',
        meta: { auth: true },
        component: () => import('../pages/van-assign/List.vue')
    },
    {
        path: 'bank-info/branch',
        name: prop + '.branch',
        meta: { auth: true },
        component: () => import('../pages/bank-info/branch/List.vue')
    },
    {
        path: 'store-item',
        name: prop + '.store_item',
        meta: { auth: true },
        component: () => import('../pages/store-item/List.vue')
    },
    {
        path: 'campaign-designation-list',
        name: prop + '.campaign_designation_list',
        meta: { auth: true },
        component: () => import('../pages/campaign-designation/List.vue')
    },
    {
        path: 'hospital-info',
        name: prop + '.hospital',
        meta: { auth: true },
        component: () => import('../pages/hospital-info/List.vue')
    },
    {
        path: 'hospital-info-add',
        name: prop + '.hospital',
        meta: { auth: true },
        component: () => import('../pages/hospital-info/Form.vue')
    },
    {
        path: 'hospital-info-thirty-percent',
        name: prop + '.hospital',
        meta: { auth: true },
        component: () => import('../pages/hospital-info-thirty-percent/List.vue')
    },
    {
        path: 'hospital-patient-welfare-association',
        name: prop + '.hospital',
        meta: { auth: true },
        component: () => import('../pages/hospital-patient-welfare-association/List.vue')
    },
    {
        path: 'bank-account',
        name: prop + '.bank_account',
        meta: { auth: true },
        component: () => import('../pages/bank-account/List.vue')
    },
    {
        path: 'hospital-fdr',
        name: prop + '.hospital_fdr',
        meta: { auth: true },
        component: () => import('../pages/hospital-fdr/List.vue')
    },
    {
        path: 'samiti-form',
        name: prop + '.samiti-form',
        meta: { auth: true },
        component: () => import('../pages/samiti-form/List.vue')
    },
    {
        path: 'assign-user',
        name: prop + '.assign_user',
        meta: { auth: true },
        component: () => import('../pages/assign-user/List.vue')
    },
    {
        path: 'assign-user-form',
        name: prop + '.assign_user_form',
        meta: { auth: true },
        component: () => import('../pages/assign-user/EntryForm.vue')
    },
    {
        path: 'assign-department',
        name: prop + '.assign_department',
        meta: { auth: true },
        component: () => import('../pages/assign-department/List.vue')
    },
    {
        path: 'assign-department-form',
        name: prop + '.assign_department_form',
        meta: { auth: true },
        component: () => import('../pages/assign-department/EntryForm.vue')
    },
    {
        path: 'assign-department-thirty-percent',
        name: prop + '.assign_department_thirty_percent',
        meta: { auth: true },
        component: () => import('../pages/assign-department-thirty-percent/List.vue')
    },
    {
        path: 'assign-department-thirty-percent-form',
        name: prop + '.assign_department_thirty_percent_form',
        meta: { auth: true },
        component: () => import('../pages/assign-department-thirty-percent/EntryForm.vue')
    },
    {
        path: 'ward',
        name: prop + '.wrd',
        meta: { auth: true },
        component: () => import('../pages/ward/List.vue')
    },
    {
        path: 'hospital-bed',
        name: prop + '.hospital_bed',
        meta: { auth: true },
        component: () => import('../pages/hospital-bed/List.vue')
    },
    {
        path: 'hospital-bed-form',
        name: prop + '.hospital_bed_form',
        meta: { auth: true },
        component: () => import('../pages/hospital-bed/EntryForm.vue')
    },
    {
        path: 'report-heading-list',
        name: prop + '.report_heading_list',
        meta: { auth: true },
        component: () => import('../pages/report-heading/List.vue')
    },
    {
        path: 'therapy-service',
        name: prop + '.therapy-service',
        meta: { auth: true },
        component: () => import('../pages/therapy-service/List')
    },
    {
        path: 'item-category',
        name: prop + '.item_category',
        meta: { auth: true },
        component: () => import('../pages/item-category/List.vue')
    },
    {
        path: 'activity-log',
        name: prop + '.activity_log',
        meta: { auth: true },
        component: () => import('../pages/activity-log/List.vue')
    }
]
const routes = [
    {
        path: '/hospital-disability-service/configuration',
        name: 'hospital_disability_service.configuration',
        component: () => import('@/layouts/HospitalDisabilityService.vue'),
        meta: { auth: true },
        children: childRoutes('hospital_disability_service.configuration')
    }
]

export default routes
